/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React  from 'react';
import { withStyles } from '@material-ui/styles';
import { array, object, string } from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import BGSStyles from './Partials/BGSAllStyles';
import BGSCms from './Partials/BGSCms';
import BGSSlider from './Partials/BGSSlider';
import BGSContactForm from './Partials/BGSContactForm';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const CorporateGiftingPage = ({
    classes, blocks, seo, code, brand,
}) => {
    const hero = blocks?.[0]?.main_hero;
    const header = blocks?.[1]?.header;
    const articles = blocks?.[2]?.articles.article;
    const slider = blocks?.[3]?.slider?.image;

    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <Container id="bgs-container" className={`${classes.BGSContactFormStyles} bgsContainer`}>
                <BGSCms articles={articles} header={header} slider={slider} hero={hero} />
                <article id="contact-us-form" className="contactUsForm row bgs-get-gifting-wrapper">
                    <Grid item sm={12}>
                        <BGSContactForm />
                    </Grid>
                </article>
                <Grid container className={`${classes.bgsSlider} bgsSliderWrapper bgs-slider-wrapper`}>
                    <BGSSlider brand={brand} code={code} />
                </Grid>
            </Container>
        </>
    );
};

CorporateGiftingPage.propTypes = {
    classes: object.isRequired,
    blocks: array.isRequired,
    seo: object.isRequired,
    brand: object.isRequired,
    code: string.isRequired,
};

export default withStyles(BGSStyles)(CorporateGiftingPage);
